<template>
    <div>
        <b-modal :hideHeaderClose="true"  no-close-on-esc no-close-on-backdrop @ok="cancelFactura" id="modal-cancelarFactura" size="xl" title="Cancelar Factura">
            <b-overlay :show="loading" rounded="sm">
                <b-row>
                    <b-col>
                        <b-alert :variant="alert.variant" :show="alert.show">{{ alert.msj }}</b-alert>
                    </b-col>
                </b-row>
                <div v-if="showContent">
                    <b-row>
                        <b-col>
                            <p>Introduce el motivo de cancelacion y los datos necesarios</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12" md="12">
                            <b-form-group label="Motivo">
                                <b-form-select v-model="cancel.motivo" :options="cancelOptions"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col lg="12" md="12" v-if="cancel.motivo=='01'">
                            <b-form-group label="Folio Sustituto">
                                <b-form-input v-model="cancel.folioSustituto"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <template #overlay>
                    <div class="text-center">
                        <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                        <p>Estamos cancelando tu factura, esto toma algun tiempo</p>
                    </div>
                </template>
            </b-overlay>
            <template #modal-footer>
                <div class="w-100">
                    <b-button :disabled="loading" variant="danger" size="sm" class="float-right" @click="closeModal">
                        Cerrar
                    </b-button>
                    <b-button :disabled="loading" variant="success" size="sm" class="float-right"
                        @click="cancelFactura">
                        Siguiente
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import axios from "axios";

export default {
    name: "cancelarFactura",
    props: ["factura_id"],
    data: () => {
        return {
            loading: false,
            cancelOptions: [
                { value: '01', text: '01 - Comprobante emitido con errores con relacion' },
                { value: '02', text: '02 - Comprobante emitido con errores sin relacion' },
                { value: '03', text: '03 - No se llevó a cabo la operacion' },
                { value: '04', text: '04 - Operación nominativa relacionada en una factura global' }
            ],
            showContent: true,
            alert: {
                show: false,
                variant: "danger",
                msj: ""
            },
            factura: {
                email: "",
                cancelado: 0,
                sucursal_id: 0
            },
            cancel: {
                motivo: "",
                folioSustituto: ""
            }
        };
    },
    computed: {},
    mounted() {
        if (this.factura_id > 0) {
            this.getFactura()
        }
    },
    watch: {
        factura_id(n) {
            if (n > 0) {
                this.getFactura()
            }
        }
    },
    methods: {
        openModal() {
            this.showContent = true
            this.alert.show = false
            this.$bvModal.show("modal-cancelarFactura")
        },
        closeModal() {
            this.$bvModal.hide("modal-cancelarFactura")
        },
        cancelFactura(e) {
            if (this.factura.cancelado == 1) {
                return
            }
            this.loading = true
            e.preventDefault()
            console.log("cancelando factura")
            let that = this
            axios
                .post("/company/1/sucursal/" + this.factura.sucursal_id + "/factura/" + this.factura_id + "/cancel", this.cancel)
                .then(function (response) {
                    that.makeToast(
                        "Exito",
                        response.data.message,
                        "success"
                    );
                    that.$emit('sent', response.data)
                    that.closeModal()
                    that.loading = false
                })
                .catch(function (err) {
                    console.log(err.request.response)
                    that.alert.show = true
                    that.alert.msj = err.request.response
                    that.loading = false

                });
        },
        getFactura() {
            let that = this;
            that.showContent = true
            that.alert.show = false
            axios
                .get("/company/1/factura/" + this.factura_id)
                .then(function (response) {
                    console.log(response.data)
                    that.factura = response.data

                    if (that.factura.cancelado == 1) {
                        that.alert.show = true
                        that.alert.variant = "danger"
                        that.alert.msj = "Dicha factura se encuentra cancelada"
                        that.showContent = false
                    }
                })
                .catch(function (err) {
                    that.alert.show = true
                    that.alert.variant = "danger"
                    that.alert.msj = err.request.response
                });
        },
        makeToast(title, content, variant) {
            this.$bvToast.toast(content, {
                title,
                variant,
                appendToast: true,
            });
        },
    },
};
</script>